import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  modalBody: {
    "& .mantine-1q36a81:not(:only-child)": {
      // padding: "0px",
      background: "#F5F5F5",
    },
  },
  modalHeader: {
    padding: "13px 19px",
    "& .mantine-Modal-title": {
      flex: 1,
      textAlign: "center",
    },
  },
  contentBoxParent: {
    padding: "16px 24px",
  },
  contentBox: {
    padding: "24px",
    borderRadius: "6px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 95,
    "& .infoText": {
      color: "#0F172A",
      fontFamily: "Inter",
      fontSize: 14,
      textAlign: "center",
      width: "85%",
      fontWeight: 400,
    },
  },
  modalTitle: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    alignItems: "center",
    fontSize: 24,
    fontFamily: "Inter",
    color: "#000",
    fontWeight: 700,
    "& svg": {
      color: "#F04438",
    },
  },
  inputField: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#344054",
      marginBottom: 8,
    },
    "& .mantine-Input-wrapper": {
      padding: "0px 12px",
      height: 48,
      borderRadius: 8,
      border: "1px solid #CBD5E1",
      background: "transparent",
      transition: "border-color 0.2s ease",

      "& input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#0F172A",

        "&::placeholder": {
          color: "#A3A3A3",
        },

        "&:focus": {
          outline: "none",
        },
      },
    },
  },
  phoneLabel: {
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#344054",
    marginBottom: 8,
  },

  pinInput: {
    fontFamily: "Inter",
  },

  login_btn: {
    "@media (max-width :48em)": {
      width: "100%",
    },
    "@media (max-width :800px)": {
      width: "100%",
    },
    background: "#000 ",
    width: "100%",
    height: rem(50),
    fontFamily: "Inter",
    fontSize: "22px",
    marginTop: 20,
    borderRadius: "4px",
    color: "#FFF",
    textAlign: "center",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    ":hover": {
      background: "#000",
      opacity: 0.8,
    },
  },
  resendLinkText: {
    marginTop: 15,
    "& .text": {
      fontSize: 14,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "#737373",
    },
    "& .resendLink": {
      textDecoration: "none",
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#FFAF4A",
    },
    "& .chooseLink": {
      color: "#000",
    },
  },

  saveBtn: {
    width: "30%",
    backgroundColor: "#FFAF4A",
    color: "#000000",
    borderRadius: "8px",
    padding: "10px 0",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "42px",
    border: "1px solid #FFAF4A",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#FFAF4A !important",
    },
  },
  loaderParent: {
    width: "100%",
    minHeight: 120,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyles;
